module.exports = __webpack_public_path__ + "static/img/Mision.13eba564.png";